import { Layout, Revisions } from "components"
export const AddRevision = () => {
 return (
  <Layout>
   <Revisions />
  </Layout>
 )
}
